import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76e31aef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "outer" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "menu"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "申請確認", -1))
const _hoisted_6 = { class: "request" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "タイトル", -1))
const _hoisted_9 = { class: "flex-margin" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "事業所", -1))
const _hoisted_12 = { class: "flex-margin" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "所属部署", -1))
const _hoisted_15 = { class: "flex-margin" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "申請者", -1))
const _hoisted_18 = { class: "flex-margin" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "申請日", -1))
const _hoisted_21 = { class: "flex-margin" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "添付ファイル", -1))
const _hoisted_24 = { class: "flex-margin" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "workflow" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow-outer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-round" })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "処理種別"),
    /*#__PURE__*/_createElementVNode("th", null, "対象者"),
    /*#__PURE__*/_createElementVNode("th", null, "結果"),
    /*#__PURE__*/_createElementVNode("th", null, "コメント"),
    /*#__PURE__*/_createElementVNode("th", null, "日時")
  ])
], -1))
const _hoisted_30 = { class: "flow-type" }
const _hoisted_31 = { class: "flow-member" }
const _hoisted_32 = { class: "flow-status" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "flow-comment" }
const _hoisted_36 = { class: "flow-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApproveBox = _resolveComponent("ApproveBox")!
  const _component_CommonCombo = _resolveComponent("CommonCombo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.currentWorkflow.target_user_code_list.some(_ => _.target_user_code === _ctx.user.id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_ApproveBox, {
                onApprove: _ctx.approve,
                onReject: _ctx.reject
              }, null, 8, ["onApprove", "onReject"])
            ]))
          : _createCommentVNode("", true),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.request.title), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getOfficeName(_ctx.request.office)), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getDepartmentName(_ctx.request.department)), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.getMemberName(_ctx.request.creator_code)), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.getDate(_ctx.request.create_date)), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("a", { href: _ctx.url }, " ダウンロード ", 8, _hoisted_25)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("table", null, [
              _hoisted_29,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflows, (workflow, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.getProcessCategoryName(workflow.process_category)), 1),
                    _createElementVNode("td", _hoisted_31, [
                      _createVNode(_component_CommonCombo, {
                        InitValue: _ctx.getTargetUserCodeList(workflow.target_user_code_list),
                        Disabled: true
                      }, null, 8, ["InitValue"])
                    ]),
                    _createElementVNode("td", _hoisted_32, [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.getStatusName(workflow.status, workflow.process_category)), 1))
                        : (_ctx.workflows[index-1].update_date && _ctx.workflows[index-1].status !== 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.getStatusName(workflow.status, workflow.process_category)), 1))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_35, _toDisplayString(workflow.comment), 1),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.getDate(workflow.update_date)), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}